import 'css-chunksrc/client/scenes/planzoneMaterialResourceAddition/styles.scss';export default {
  "group": "_group_10r8x_1",
  "text": "_text_10r8x_5",
  "name": "_name_10r8x_10",
  "main": "_main_10r8x_16",
  "buttons": "_buttons_10r8x_23"
};